// src/services/contactActivityTypes.ts
import { apiJson } from './http';

export type ContactActivityTypeDTO = {
  id: number;
  label: string;
  icon?: string | null;
  active: boolean;
};

export async function listContactActivityTypes(onlyActive = true): Promise<ContactActivityTypeDTO[]> {
  const qs = onlyActive ? '?active=true' : '';
  return apiJson<ContactActivityTypeDTO[]>(`/p/contact-activity-types${qs}`);
}

export async function createContactActivityType(payload: Partial<ContactActivityTypeDTO>) {
  return apiJson<ContactActivityTypeDTO>('/p/contact-activity-types', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateContactActivityType(id: number, payload: Partial<ContactActivityTypeDTO>) {
  return apiJson<ContactActivityTypeDTO>(`/p/contact-activity-types/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}
